import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiDownload, FiSmartphone } = FiIcons;

const PWAPrompt = ({ show, onClose }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if iOS
    setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent));

    // Check if already installed
    setIsStandalone(window.matchMedia('(display-mode: standalone)').matches);

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response to install prompt: ${outcome}`);
      setDeferredPrompt(null);
      onClose();
    }
  };

  const handleIOSInstall = () => {
    alert('To install: Tap the share button and select "Add to Home Screen"');
    onClose();
  };

  if (!show || isStandalone) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        className="fixed bottom-4 left-4 right-4 z-50"
      >
        <div className="glass-effect rounded-2xl p-6 shadow-2xl border border-slate-200">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
                <SafeIcon icon={FiSmartphone} className="text-white text-xl" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-800">Install CoAgree AI</h3>
                <p className="text-sm text-slate-600">Access offline and get the full experience</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-1 text-slate-500 hover:text-slate-700 transition-colors"
            >
              <SafeIcon icon={FiX} />
            </button>
          </div>

          <div className="flex gap-3">
            <button
              onClick={isIOS ? handleIOSInstall : handleInstallClick}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <SafeIcon icon={FiDownload} />
              {isIOS ? 'Add to Home Screen' : 'Install App'}
            </button>
            <button
              onClick={onClose}
              className="px-4 py-3 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PWAPrompt;